/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-08-05 09:11:04
 */

import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/oms-interconnection-service/v1";

// 分页获取互联互通服务
export const getInterflowList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/page", data, config);
};

//增加互联互通服务
export const addInterflow = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/add", data, config);
};
//修改互联互通服务
export const upInterflow = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/update", data, config);
};
//互联互通-已添加站点
export const getBindStaList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/already_bind_sta", data, config);
};
//互联互通-未添加站点
export const getNotBindStaList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/not_bind_sta", data, config);
};
//互联互通-站点关联
export const InterflowBindSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/bind_sta", data, config);
};
//互联互通-获取平台密钥
export const getPlatformKey = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/get_platform_key", data, config);
};
//互联互通-获取平台密钥
export const updPlatformKey = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/upd_platform_key", data, config);
};
//互联互通-更新运营商密钥
export const updSecuritykey = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/upd_security_key", data, config);
};
//互联互通-获取运营商密钥
export const getSecurityKey = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/get_security_key", data, config);
};
//互联互通-获取协议下拉框选择
export const getProtocolList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/get_protocol", data, config);
};
//分页查询接口会员
export const getInterfaceuserList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/interfaceuser/page", data, config);
};
//新增接口会员信息
export const addInterfaceuser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/interfaceuser/add", data, config);
};
//修改接口会员
export const updInterfaceuser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/interfaceuser/upd", data, config);
};
//注销接口会员
export const delInterfaceuser = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/interfaceuser/del", data, config);
};
//接口会员统计信息
export const getInterfaceuserStatistics = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/interfaceuser/statistics", data, config);
};
//获取接口会员的充值 充电总金额
export const getInterfaceuserMoney = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-order-service/v1/money/record/total/interface_member",
    data,
    config
  );
};
//接口会员的充值
export const interfaceRecharge = (data = {}, config: objAny = {}) => {
  return request("/oms-order-service/v1/recharge/cash/interface", data, config);
};
//接口会员的充值记录根据账户id分页查询接口会员充值记录
export const interfaceRechargeRecord = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-order-service/v1/money/record/page/interface_member",
    data,
    config
  );
};
// 根据账户id分页查询退款记录复制
export const interfaceRefundRecord = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-order-service/v1/money/record/page/refund/by_account",
    data,
    config
  );
};

//接口会员的充值\电记录
export const interfaceOrderRecord = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-charge-service/v1/order/page/interface_member",
    data,
    config
  );
};
//接口会员已绑定站点
export const interfaceAlreadyBindSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-interconnection-service/v1/interflow/already_bind_sta",
    data,
    config
  );
};
//接口会员未绑定站点
export const interfaceNotBindSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-interconnection-service/v1/interflow/not_bind_sta",
    data,
    config
  );
};
//接口会员站点保存
export const interfaceBindSta = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-interconnection-service/v1/interflow/bind_sta",
    data,
    config
  );
};
//接口会员的充值
export const memberUpdPlatformKey = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/interfaceuser/upd_platform_key", data, config);
};
